export const CELLS_ORDER = [
    [100, 99, 98, 97, 96, 95, 94, 93, 92, 91],
    [81, 82, 83, 84, 85, 86, 87, 88, 89, 90],
    [80, 79, 78, 77, 76, 75, 74, 73, 72, 71],
    [61, 62, 63, 64, 65, 66, 67, 68, 69, 70],
    [60, 59, 58, 57, 56, 55, 54, 53, 52, 51],
    [41, 42, 43, 44, 45, 46, 47, 48, 49, 50],
    [40, 39, 38, 37, 36, 35, 34, 33, 32, 31],
    [21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
    [20, 19, 18, 17, 16, 15, 14, 13, 12, 11],
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
];

export const CELL_INFO = {
    //Kuis
    7: {
        type: "Kuis",
        text: "Kristus berasal dari bahasa Yunani \"Christos\" yang berarti ...",
        answer: "Yang diurapi",
    },
    13: {
        type: "Kuis",
        text: "Sebutkan suku-suku yang masih belum mendengar injil di daerah Jawa Timur dan sekitarnya (min. 3 suku)!",
        answer: "",
    },
    21: {
        type: "Kuis",
        text: "Mengapa Kristus harus 100% manusia?",
        answer: "Darah Kristus adalah darah yang sempurna dan hanya melalui darah-Nya, manusia bisa diselamatkan.",
    },
    36: {
        type: "Kuis",
        text: "Bagaimana cara menghidupi kasih Allah?",
        answer: "Lakukan dengan tindakan nyata serta harus ada kemauan dari dalam diri (tanpa paksaan).",
    },
    50: {
        type: "Kuis",
        text: "Apa artinya bahwa Yesus adalah Anak Domba Allah?",
        answer: "Yesus adalah korban utama yang sempurna untuk menebus dosa manusia.",
    },
    53: {
        type: "Kuis",
        text: "Apakah ada dosa yang tidak dapat diampuni?",
        answer: "Tidak ada, kecuali tidak percaya pada Tuhan Yesus.",
    },
    63: {
        type: "Kuis",
        text: "Mengapa Kristus harus 100% Allah?",
        answer: "Yesus melakukan karya yang hanya dikerjakan oleh Allah.",
    },
    74: {
        type: "Kuis",
        text: "Apakah yang membedakan kasih Allah kepada umat-Nya dan orang yang bukan umat-Nya?",
        answer: "Tuhan mengasihi semua manusia, tapi kasih-Nya kepada orang Kristen berbeda. Orang Kristen menerima anugrah selama-lamanya dan mendapatkan kehidupan kekal.",
    },
    84: {
        type: "Kuis",
        text: "Sebutkan 2 bukti Alkitab benar-benar firman Allah!",
        answer: "Tidak lekang oleh waktu, tidak bisa habis dipelajari, kesesuaian sejarah berdasarkan penemuan historis, dll.",
    },
    91: {
        type: "Kuis",
        text: "Apakah “sekali selamat tetap selamat” itu benar berdasarkan Alkitab? Apa alasannya (berdasarkan ayat Alkitab)?",
        answer: "Benar, Yohanes 10:28-29 “dan Aku memberikan hidup yang kekal kepada mereka dan mereka pasti tidak akan binasa sampai selama-lamanya dan seorangpun tidak akan merebut mereka dari tangan-Ku. Bapa-Ku, yang memberikan mereka kepada-Ku, lebih besar dari pada siapapun, dan seorangpun tidak dapat merebut mereka dari tangan Bapa.”",
    },

    //Challenge
    10: {
        type: "Challenge",
        text: "Nyanyikan lagu bertemakan kasih oleh minimal 3 orang dalam satu kelompok!",
    },
    17: {
        type: "Challenge",
        text: "Chat salah satu teman yang tidak datang hari ini.",
    },
    25: {
        type: "Challenge",
        text: "Buatlah cerita bertemakan 'Anak Tuhan' dengan sambung kata \n (harus ada perkenalan, masalah, dan penyelesaian masalah; tidak boleh diskusi)!",
    },
    34: {
        type: "Challenge",
        text: "Diskusikan satu warna. Setelah itu, carilah barang-barang dengan warna tersebut (harus semua dapat)!",
    },
    43: {
        type: "Challenge",
        text: "Tirukan salah satu gaya pembicara di remaja!",
    },
    57: {
        type: "Challenge",
        text: "Buatlah sebuah yel-yel dengan tema 'Yesus Sahabatku'!",
    },
    67: {
        type: "Challenge",
        text: "Membuat pose di zoom (utamakan kekompakan)!",
    },
    82: {
        type: "Challenge",
        text: "Menebak gerakan oleh salah satu tim!",
    },

    //Ayat
    11: {
        type: "Ayat",
        text: "Markus 12:30",
        description: "Kasihilah Tuhan, Allahmu, dengan segenap hatimu dan dengan segenap jiwamu dan dengan segenap akal budimu dan dengan segenap kekuatanmu.",
    },
    38: {
        type: "Ayat",
        text: "Roma 5:5",
        description: "Dan pengharapan tidak mengecewakan, karena kasih Allah telah dicurahkan di dalam hati kita oleh Roh Kudus yang telah dikaruniakan kepada kita.",
    },
    47: {
        type: "Ayat",
        text: "Yohanes 14:6",
        description: "Kata Yesus kepadanya “Akulah jalan kebenaran dan hidup. Tidak ada seorangpun yang datang kepada bapa, kalau tidak melalui aku.",
    },
    61: {
        type: "Ayat",
        text: "Matius 28:19",
        description: "Karena itu pergilah, jadikanlah semua bangsa murid-Ku dan baptislah mereka dalam nama Bapa dan Anak dan Roh Kudus.",
    },
    86: {
        type: "Ayat",
        text: "Mazmur 16:11",
        description: "Engkau memberitahukan kepadaku jalan kehidupan; di hadapan-Mu ada sukacita berlimpah-limpah, di tangan kanan-Mu ada nikmat senantiasa.",
    },

    //Golden Ticket
    19: {
        type: "Golden Ticket",
        text: "Selamat!",
    },
    37: {
        type: "Golden Ticket",
        text: "Selamat!",
    },
    45: {
        type: "Golden Ticket",
        text: "Selamat!",
    },
    66: {
        type: "Golden Ticket",
        text: "Selamat!",
    },
    83: {
        type: "Golden Ticket",
        text: "Selamat!",
    },
    100: {
        type: "Yay!",
        text: "Kamu telah sampai tujuan dengan selamat",
    }
}

export const CELL_TYPE = {
    // ladder
    2: {
        type: "ladder",
        to: 38,
    },
    7: {
        type: "ladder",
        to: 14,
    },
    8: {
        type: "ladder",
        to: 31,
    },
    15: {
        type: "ladder",
        to: 26,
    },
    21: {
        type: "ladder",
        to: 42,
    },
    28: {
        type: "ladder",
        to: 84,
    },
    36: {
        type: "ladder",
        to: 44,
    },
    51: {
        type: "ladder",
        to: 67,
    },
    71: {
        type: "ladder",
        to: 91,
    },
    78: {
        type: "ladder",
        to: 98,
    },
    87: {
        type: "ladder",
        to: 94,
    },

    // snake
    16: {
        type: "snake",
        to: 6,
    },
    46: {
        type: "snake",
        to: 25,
    },
    49: {
        type: "snake",
        to: 11,
    },
    62: {
        type: "snake",
        to: 19,
    },
    64: {
        type: "snake",
        to: 60,
    },
    74: {
        type: "snake",
        to: 53,
    },
    89: {
        type: "snake",
        to: 68,
    },
    92: {
        type: "snake",
        to: 88,
    },
    95: {
        type: "snake",
        to: 75,
    },
    99: {
        type: "snake",
        to: 80,
    },
}

export const DEFAULT_PLAYERS = [
    {
        id: "1",
        name: "Tim 1",
        pos: 1,
        color: "#ff0000",
    },
    {
        id: "2",
        name: "Tim 2",
        pos: 1,
        color: "#00ff00",
    },
    {
        id: "3",
        name: "Tim 3",
        pos: 1,
        color: "#0000ff",
    },
    
]
